import { useTranslation } from "react-i18next"


export default function CostRefundReport({
    costRefundReportUi
}) {

    const [t] = useTranslation(["global", "absenceReport"])

    return <>


        <div className="card bg-black bg-opacity-10 text-white mb-4">
            <div className="card-header">
                <i className="fa-solid fa-chart-simple"></i> {t("absenceReport:menu.cost_refunds")}
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col ps-4">
                      <i className="muted"><span className="text-eh">Accettate</span>  in questo mese</i> 
                        <h3>{costRefundReportUi.reports.length} </h3>
                    </div>
                    <div className="col">
                        <i className="text-muted">Totale spesa</i>
                        <h3><i className="fa-solid fa-coins"></i> {costRefundReportUi.costTotal.toFixed(2)} <i className="text-muted">€</i> </h3>
                    </div>
                    <div className="col">
                    <i className="text-muted">Totale percorrenza</i>
                        <h3><i className="fa-solid fa-road"></i> {costRefundReportUi.distanceTotal} <i className="text-muted">km</i> </h3>
                    </div>
                    <div className="col-auto">
                        {costRefundReportUi.reports.length > 0 &&
                            <table className="table table-dark table-hover text-end ">
                                <thead>
                                    <tr>
                                        <td ></td>
                                        <td className="col opacity-50"><i className="fa-solid fa-road"></i> Percorrenza</td>
                                        <td className="col opacity-50"><i className="fa-solid fa-coins"></i> Spesa</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {costRefundReportUi.reports.map((report, i) => {
                                        return (
                                            <tr key={report.userDisplayName}>
                                                <td>{report.userDisplayName}</td>
                                                <td>{report.distanceSum} <i className="text-muted">km</i></td>
                                                <td>{report.costSum.toFixed(2)} <i className="text-muted">€</i></td>
                                            </tr>

                                        )

                                    })}
                                </tbody>
                            </table>

                        }
                    </div>




                </div>
            </div>
        </div>


    </>

}